// ** React Imports
import { Fragment, useState, useEffect } from 'react'
import { MessageCircle, X, ArrowLeft } from 'react-feather'
import { DropdownToggle, Badge, UncontrolledDropdown, Modal, ModalBody, ModalHeader  } from 'reactstrap'

// ** Chat App Component Imports
import Sidebar from './SidebarLeft'

import '@styles/base/pages/app-chat.scss'
import '@styles/base/pages/app-chat-list.scss'
import CardChat from "./CardChat"
import useApi from '@hooks/useApi'
import useLoader from '@hooks/useLoader';
import SocketActions from "./actions"

import useWs from "@hooks/useWS"


const AppChat = () => {
    // ** Store Vars
    const ChatApi = useApi().chat
    const { fetchData } = useLoader({})

    // ** States
    const [user, setUser] = useState({})
    const [sidebar, setSidebar] = useState(false)
    const [roomData, setRoomData] = useState(null)
    const [chat_modal, setChatModal] = useState(false)

    // ** Sidebar & overlay toggle functions
    const handleSidebar = () => {
        setSidebar(!sidebar)
        setChatModal(false)
    }

    const {data, setData, isSocketConnected, socketSend} = useWs({
        roomId: undefined,
        action: {
            /** Online хэрглэгчийн жагсаалтын сонсох нь */
            [SocketActions.UNREAD_CHAT_COUNT]: {
                initData: [],
                format: (prev, newData) =>
                {
                    return newData?.count ?? []
                }
            },
            /** Online хэрглэгчийн жагсаалтын сонсох нь */
            [SocketActions.MESSAGE]: {
                initData: [],
                format: (prev, newData) =>
                {
                    setUnreadRoomList(newData)
                }
            },
        },
    })
    const unreadRoomList = data[SocketActions.UNREAD_CHAT_COUNT]
    // const chatData = data[SocketActions.MESSAGE]

    /** hook set data */
    const setUnreadRoomList = (data) =>
    {
        setData((prev) =>
        {
            if(prev?.unreadChatCount && data?.roomId && !prev?.unreadChatCount?.includes(data?.roomId))
            {
                prev.unreadChatCount.push(data?.roomId)
            }
            return prev
        })
    }

    /** socket connect хийгдэх үед ашиглана  */
    useEffect(
        () =>
        {
            if(isSocketConnected)
            {
                /** Тухайн хэрэглэгчийн уншаагүй чатны тоог сонсох */
                socketSend({
                    action: SocketActions.GET_ONLINE_USER,
                    user: user.userDetail?.id,
                    roomId: null,
                })
            }
        },
        [isSocketConnected]
    )

    /** Өрөөний мэдээлэл back-аас авах */
    async function handleModal(id, type)
    {
        if(id && type)
        {
            const {success, data} = await fetchData(ChatApi.checkRoom({id, type}))
            if(success) {
                setRoomData(data)
            }
        }
        setChatModal(!chat_modal)
    }

    // ** Set user function for Right Sidebar
    const handleUser = obj => setUser(obj)

    const CloseBtn = (
        <X className="cursor-pointer" size={15} onClick={handleSidebar} />
    )

    return (
        <div>
            <UncontrolledDropdown tag='li' className='dropdown-notification nav-item me-25'>
                <DropdownToggle tag='a' className='nav-link' href='/' onClick={e => e.preventDefault()}>
                    <MessageCircle  onClick={handleSidebar} role='button'/>

                    {
                        unreadRoomList && unreadRoomList.length > 0
                        ? <Badge pill color='danger' className='badge-up'> {unreadRoomList.length} </Badge>
                        : null
                    }
                </DropdownToggle>
            </UncontrolledDropdown>
            <Modal
                isOpen={sidebar}
                toggle={handleSidebar}
                className="sidebar-lg hr-register"
                modalClassName="modal-slide-in"
                contentClassName="pt-0 pb-0"
            >
                <ModalHeader
                    toggle={handleSidebar}
                    close={CloseBtn}
                    tag="div"
                >
                    <h5 className="modal-title">{ chat_modal && <ArrowLeft role={"button"} className="me-50" size={15} onClick={handleModal} />}{'Чат'}</h5>
                </ModalHeader>
                <ModalBody className="flex-grow-1"
                style={
                    chat_modal
                    ?
                    {
                        padding: 0,
                        paddingBottom: 0,
                        height: '100%',
                    }
                    :
                    null
                }
                >
                    {
                        chat_modal
                        ?
                            <CardChat data={roomData} />
                        :
                            <Sidebar handleChatModal={handleModal} />
                    }
                </ModalBody>
            </Modal>
        </div>
    )
}

export default AppChat
